import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { AuthService } from '../services/auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isApiUrl = request.url.startsWith(environment.apiUrl);
    let headers = request.headers;

    if (this.isMultiformRequest(request)) {
      //Content type should be removed for correct file uploading
      headers = headers.delete('Content-Type');
    } else {
      headers = headers.set('Content-Type', 'application/json');
    }

    headers = headers.set('X-Api-Version', environment.apiVersion);
    request = request.clone({
      headers,
    });
    return next.handle(request);
  }

  private isMultiformRequest(request: HttpRequest<any>): boolean {
    return request.headers.get('Content-Type') === 'multipart/form-data';
  }
}
